import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../assets/icons/trash-icon.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "modal__content"
}
const _hoisted_3 = { class: "tw-w-full tw-flex tw-items-start tw-gap-4 tw-justify-between" }
const _hoisted_4 = { class: "member-list-card__item_info rmd:!tw-items-start" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "tw-rounded-full tw-overflow-hidden tw-max-h-[48px] tw-max-w-[48px] tw-min-h-[48px] tw-min-w-[48px] tw-h-[48px] tw-relative"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "tw-rounded-full tw-overflow-hidden tw-max-h-[48px] tw-max-w-[48px] tw-min-h-[48px] tw-min-w-[48px] tw-h-[48px] tw-relative"
}
const _hoisted_9 = { class: "profile_info_wrapper" }
const _hoisted_10 = { class: "text-wrap" }
const _hoisted_11 = { class: "member-list-first-row !tw-flex-wrap" }
const _hoisted_12 = { class: "member-list-info" }
const _hoisted_13 = { class: "member-list-name" }
const _hoisted_14 = { class: "custom_tags desktop_wrapper !tw-flex-wrap" }
const _hoisted_15 = { class: "member-list-role" }
const _hoisted_16 = { class: "member-list-tag" }
const _hoisted_17 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-end" }
const _hoisted_18 = {
  key: 0,
  class: "action-btn-wrap"
}
const _hoisted_19 = { class: "custom_tags mobile_wrapper tw-flex-wrap tw-flex-start tw-w-full" }
const _hoisted_20 = { class: "member-list-role" }
const _hoisted_21 = { class: "member-list-tag" }
const _hoisted_22 = {
  key: 1,
  class: "modal__content"
}
const _hoisted_23 = { class: "member-loader" }
const _hoisted_24 = { class: "modal__footer tw-pt-4 tw-border-t-dashed-custom" }
const _hoisted_25 = { class: "modal__content" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "modal__content_img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_27 = { class: "modal__content_header" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", null, "Deactivate Team Member?", -1)
const _hoisted_29 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ProfileThumbnail = _resolveComponent("ProfileThumbnail")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_AcceptChip = _resolveComponent("AcceptChip")!
  const _component_PendingChip = _resolveComponent("PendingChip")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_AddTeamMemberModal = _resolveComponent("AddTeamMemberModal")!
  const _component_EditTeamMemberModal = _resolveComponent("EditTeamMemberModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowTeamMemberList)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 0,
          isShowHeader: false,
          isShowBackButton: false,
          className: ['team_member_dialog'],
          width: "700px",
          height: "auto"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h4", null, "Manage Team (" + _toDisplayString($setup.modifiedMembers?.length) + ")", 1),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                onClick: $setup.onClickCloseButton
              }, null, 8, ["onClick"])
            ]),
            ($setup.modifiedMembers?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.modifiedMembers, (member, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "member-list-card__item !tw-flex-col tw-gap-0 rmd:!tw-gap-4",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          (index === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (member?.userProfileImageUrl)
                                  ? (_openBlock(), _createBlock(_component_ProfileThumbnail, {
                                      key: 0,
                                      size: "md",
                                      isRounded: false,
                                      src: member?.userProfileImageUrl
                                    }, null, 8, ["src"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createVNode(_component_UserProfileLogo, {
                                        userName: member?.userName,
                                        mobileFontSizeBig: true
                                      }, null, 8, ["userName"])
                                    ]))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (member?.userProfileImageUrl)
                                  ? (_openBlock(), _createBlock(_component_ProfileThumbnail, {
                                      key: 0,
                                      size: "md",
                                      isRounded: false,
                                      src: member?.userProfileImageUrl
                                    }, null, 8, ["src"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createVNode(_component_UserProfileLogo, {
                                        userName: member?.email,
                                        mobileFontSizeBig: true,
                                        desktopFontSizeMid: true
                                      }, null, 8, ["userName"])
                                    ]))
                              ])),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(member?.userName
                            ? member?.userName
                            : member?.email?.split("@")[0]), 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(member?.role), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseJSON(member?.tags), (tag) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "member-list-tags",
                                      key: tag
                                    }, [
                                      _createElementVNode("div", _hoisted_16, _toDisplayString(tag), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("p", null, _toDisplayString(member?.email), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          (index !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createVNode(_component_v_btn, {
                                  icon: "mdi-pencil",
                                  variant: "text",
                                  color: "#80829F",
                                  onClick: ($event: any) => ($setup.onClickEditTeamMember(member))
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  icon: "mdi-delete",
                                  variant: "text",
                                  color: "#80829F",
                                  class: "delete__btn",
                                  onClick: ($event: any) => ($setup.onClickRemoveTeamMember(member?.id, member?.name))
                                }, null, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (index > 0 && member.invitationStatus !== 'pending')
                            ? (_openBlock(), _createBlock(_component_AcceptChip, {
                                key: 1,
                                label: "Accepted",
                                isDense: true
                              }))
                            : _createCommentVNode("", true),
                          (index > 0 && member.invitationStatus === 'pending')
                            ? (_openBlock(), _createBlock(_component_PendingChip, {
                                key: 2,
                                isDense: true
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(member?.role), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseJSON(member?.tags), (tag) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "member-list-tags",
                            key: tag
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(tag), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128)),
                  _createVNode(_component_CommonLoader, {
                    class: "tw-mx-auto tw-my-3",
                    loading: $setup.memberAddedLoader
                  }, null, 8, ["loading"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_CommonLoader, { loading: true })
                  ])
                ])),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Button, {
                variant: "secondary",
                class: "!tw-w-auto",
                label: "Add New Member",
                onClick: $setup.onClickAddTeamMember
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                variant: "accent",
                class: "!tw-w-auto",
                label: "Done",
                onClick: $setup.onClickCloseButton
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.isShowRemoveTeamMemberModal)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 1,
          isShowHeader: false,
          onClickBackButton: $setup.onClickBackButton,
          className: ['remove_team_member_dialog'],
          width: "350px"
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("p", null, [
                  _createTextVNode(" Are you sure you want to deactivate "),
                  _createElementVNode("strong", null, _toDisplayString($setup.memberName), 1),
                  _createTextVNode(" Account? ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_Button, {
                variant: "accent",
                isLoading: $setup.deleteMemberLoader,
                label: "Confirm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickConfirmRemoveTeamMember($setup.userMemberId)))
              }, null, 8, ["isLoading"])
            ])
          ]),
          _: 1
        }, 8, ["onClickBackButton"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.ADDTEAMMEMBER)
      ? (_openBlock(), _createBlock(_component_AddTeamMemberModal, {
          key: 2,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.openedModel === $setup.modelName.EDITTEAMMEMBER)
      ? (_openBlock(), _createBlock(_component_EditTeamMemberModal, {
          key: 3,
          memberData: $setup.memberData,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["memberData", "onOnClickCloseTab"]))
      : _createCommentVNode("", true)
  ], 64))
}